var $ = require("./lib/qsa");
var trackEvent = require("./lib/tracking");

var Player = function (timer) {
  this.timer = timer;
  this.button = $.one(".play-pause");
  this.playing = true;

  this.button.addEventListener("click", () => this.onClick());

  this.onClick = function () {
    this.playing ? this.pause() : this.play();
  };

  this.play = function () {
    this.button.setAttribute("aria-pressed", "true");
    this.playing = true;

    this.button.classList.remove("paused");
    this.button.classList.add("started");
    document.body.classList.remove("paused");

    this.timer.play(true);
  };

  this.pause = function () {
    this.button.setAttribute("aria-pressed", "false");
    this.playing = false;

    this.timer.pause();

    this.button.classList.add("paused");
    document.body.classList.add("paused");
  };

  // TODO: better way to do this?
  this.resetTime = function () {
    this.button.classList.remove("started");

    void this.button.offsetWidth;

    this.button.classList.add("started");
  };
};

module.exports = { Player };
